/* eslint-disable no-nested-ternary */
import React from 'react';
import { array, bool, object } from 'prop-types';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import SuccessCheckGreen from 'yoda-core-components/lib/assets/svg/SuccessCheckGreen.svg';
import {
    COUPONS_APPLIED_LABEL,
    COUPONS_NON_RESTRICTED_PAYMENTS,
    COUPONS_RESTRICTED_PAYMENTS,
    COUPONS_UPDATED_NON_RESTRICTED_PAYMENTS,
    COUPONS_UPDATE_LABEL,
} from '../../common/Constants';

const CMCouponApplied = (props) => {
    const { appliedAdjustments, bagItems, ifCouponAlreadyApplied, item } = props;
    let savings = null;
    let appliedCouponCode = null;
    const applyCoupon = appliedAdjustments && appliedAdjustments[0]?.value;
    const isMessageAvailable = appliedAdjustments && appliedAdjustments[0]?.message;
    const promoLength = !isEmpty(item?.promoCode);
    const isAdjustmentApplied = appliedAdjustments && appliedAdjustments?.length > 0;
    let appliedAdjustment = null;
    let eligibleItemsInCart = false;
    const hasEligibleItemsInCart = !isEmpty(
        bagItems?.find((bagItem) => bagItem?.adjustments?.length > 0)
    );

    /* istanbul ignore next */
    if (promoLength) {
        if (isAdjustmentApplied) {
            appliedAdjustment = find(
                appliedAdjustments,
                (adjustment) =>
                    adjustment.value?.toUpperCase() === item?.promoCode?.trim().toUpperCase()
            );
        }
        savings = appliedAdjustment
            ? appliedAdjustment?.amount &&
              appliedAdjustment?.amount > 0 &&
              parseFloat(appliedAdjustment?.amount)
            : null;
        appliedCouponCode = appliedAdjustment?.value;
    }

    /* istanbul ignore next */
    if (
        promoLength &&
        appliedAdjustments?.bestCoupons &&
        appliedAdjustments?.bestCoupons?.length > 0
    ) {
        const { bestCoupons } = appliedAdjustments;
        const isBestCoupon = find(
            bestCoupons,
            (bestcoupon) =>
                bestcoupon?.promoCode?.toUpperCase() === item?.promoCode?.trim().toUpperCase()
        );
        savings = isBestCoupon?.totalDiscount ? isBestCoupon?.totalDiscount : null;
        appliedCouponCode = isBestCoupon ? isBestCoupon?.promoCode : null;
    }

    /* istanbul ignore next */
    if (hasEligibleItemsInCart) {
        eligibleItemsInCart = true;
    }

    return (
        <div>
            {item?.promoCode === applyCoupon ? (
                <div className={dt(['text-[#4D4D4D]', 'text-sm', 'leading-5'])}>
                    <Icon
                        iconType="svg"
                        automationId="coupon-applied"
                        width="24px"
                        height="18px"
                        viewBox="0 0 24 18"
                    >
                        <SuccessCheckGreen />
                    </Icon>
                    <span className={dt(['font-semibold'])}>
                        {ifCouponAlreadyApplied
                            ? COUPONS_UPDATE_LABEL.toUpperCase()
                            : COUPONS_APPLIED_LABEL.toUpperCase()}
                    </span>
                    {savings > 0 &&
                        !isEmpty(appliedCouponCode) &&
                        item?.promoCode === appliedCouponCode && (
                            <div className={dt(['text-[#E71324]', 'font-bold'])}>
                                You are Saving ${savings.toFixed(2)}
                            </div>
                        )}
                    <div className={dt(['font-normal', 'text-xs', 'leading-4'])}>
                        {!isEmpty(isMessageAvailable)
                            ? isMessageAvailable
                            : props.item?.tenderType === 'NORESTRICTION'
                            ? props.ifCouponAlreadyApplied
                                ? COUPONS_UPDATED_NON_RESTRICTED_PAYMENTS
                                : !savings && COUPONS_NON_RESTRICTED_PAYMENTS
                            : COUPONS_RESTRICTED_PAYMENTS}
                    </div>
                </div>
            ) : (
                savings > 0 &&
                !isEmpty(appliedCouponCode) &&
                props?.item?.promoCode === appliedCouponCode && (
                    <div
                        className={dt([
                            'text-sm',
                            'text-[#E71324]',
                            'font-bold',
                            'pb-2',
                            'leading-5',
                        ])}
                    >
                        Save ${savings.toFixed(2)}
                    </div>
                )
            )}
        </div>
    );
};

CMCouponApplied.propTypes = {
    appliedAdjustments: array,
    bagItems: array,
    ifCouponAlreadyApplied: bool,
    item: object,
};

CMCouponApplied.defaultProps = {
    appliedAdjustments: [],
    bagItems: [],
    ifCouponAlreadyApplied: false,
    item: {},
};

export default CMCouponApplied;
